import React, { Component } from "react";
import { Link } from "react-router-dom";
import { getApiUrl } from "../helpers/Util";
import { createNotification } from "../helpers/Notification";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import MasterDataService from "../services/MasterDataService";
import ConfirmBox from "../common/ConfirmBox";
import Loader from "../common/Loader";
import { setLocalStorageMasterDataItems, getLocalStorageMasterDataItems, removeLocalStorageMasterDataItems } from "../project/Helper";


export default class FieldCrewList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fieldCrewData: [],
      search: "",
      isShowConfirmBox: false,
      loader: false,
      removeId: "",
      resDataLen:0,
      // pagination constants----
      pageChange: 1,
      skip: 0,
      limit: 10,
      count: 0,
    };
  }

  componentDidMount = () => {
    // const { skip, limit } = this.state;
    // let filters = `?filter[skip]=${skip}&filter[limit]=${limit}`;
    this.getFieldCrewPaginationConstants()
    
  };

  getFieldCrewPaginationConstants=()=>{
      const { skip, limit } = this.state;
          const data = getLocalStorageMasterDataItems("fieldCrewListPaginationConstants");
          console.log(data);
          let filters
          if (data !== null && data !== undefined) {
      
            const { fieldCrewLimit, fieldCrewPageChange, fieldCrewSkip } = data;
            this.setState({ pageChange: fieldCrewPageChange, limit: fieldCrewLimit, skip: fieldCrewSkip }, () => {
              filters = `?filter[skip]=${fieldCrewSkip}&filter[limit]=${fieldCrewLimit}`
             this.getFieldCrewList(filters);
              removeLocalStorageMasterDataItems("fieldCrewListPaginationConstants")
            })
          } else {
            filters = `?filter[skip]=${skip}&filter[limit]=${limit}`;
           this.getFieldCrewList(filters);
          }
    }
  getFieldCrewList = async (filters) => {
    MasterDataService.getFieldCrews(filters)
      .then((response) => {
        if (response.status) {
          let responseData = response.data.data.data;
          let count = response.data.data.count;
          this.handleFieldCrewList(responseData, count);
        }
      })
      .catch((error) => {
        if (error.response.status === 401) {
          createNotification("error", "Your login session has been expired!");
          localStorage.clear();
          this.props.history.push("/login");
          //this.setState({loader:false});
        } else {
          createNotification("error", error.response.data.error.message);
          //this.setState({loader:false});
        }
      });
  };

  handleFieldCrewList = (responseData, count) => {
    const URL = getApiUrl();
    let listArr = [];
    responseData &&
      responseData.map((item) => {


        let itemData = { ...item };
        itemData.status = itemData.status;
        itemData.manager = itemData.fkey_manager ? itemData.fkey_manager.name : "N/A"
        listArr.push(itemData);
      });
    this.setState({ fieldCrewData: listArr, count: count,resDataLen:responseData.length });
  };

  imageFormat = (cell, row, rowIndex, formatExtraData) => {

    return (
      <div>
        <a href="#" className="text-body">
          {row.name}
        </a>
      </div>
    );
  };

  actionFormat = (cell, row, rowIndex, formatExtraData) => {
    return (
      <div>
        <td>
          <ul className="list-inline mb-0">
            <li className="list-inline-item" onClick={this.setLocalStorageItems}>
              <Link to={`/fieldcrew/${row.id}`}>
                <i className="uil uil-pen font-size-18"></i>
              </Link>
            </li>
            <li className="list-inline-item">
              <a href="javascript:void(0)" className="text-danger">
                <i className="uil uil-trash-alt font-size-18" onClick={() => this.setState({ removeId: row.id, isShowConfirmBox: true })}></i>
              </a>
            </li>
          </ul>
        </td>
      </div>
    );
  };


   setLocalStorageItems = () => {
      const { pageChange, skip, limit } = this.state;
      let data = {
        fieldCrewPageChange: pageChange,
        fieldCrewSkip: skip,
        fieldCrewLimit: limit
      }
      setLocalStorageMasterDataItems("fieldCrewListPaginationConstants", data);
    }

  handleConfirmModal = (isYes, id = "") => {
    if (isYes) {
      this.setState({
        isShowConfirmBox: !this.state.isShowConfirmBox,
        loader: true,
      });
      const { removeId ,resDataLen,pageChange} = this.state;
      let filters;
      if(resDataLen===1 && pageChange>1){
       
        let localskip =this.state.skip-this.state.limit;
        let localPage=this.state.pageChange-1;
        
      this.setState({skip:localskip,pageChange:localPage},()=>{
        filters  = `?filter[skip]=${localskip}&filter[limit]=${this.state.limit}`;
      })        
      }else{
        filters = `?filter[skip]=${this.state.skip}&filter[limit]=${this.state.limit}`;
        
      }
      MasterDataService.deleteFieldCrewById(removeId)
        .then((response) => {
          if (response.status) {
            createNotification("success", "Field Crew deleted successfully");
            this.setState({ removeId: "", isShowConfirmBox: false, loader: false });
            this.getFieldCrewList(filters);
          }
          console.log({ locationList: response });
        })
        .catch((error) => {
          if (error?.response?.status === 401) {
            createNotification("error", "Your login session has been expired!");
            localStorage.clear();
            this.props.history.push("/login");
            //this.setState({loader:false});
          } else {
            createNotification("error", error?.response?.data.error.message);
            //this.setState({loader:false});
            this.setState({ removeId: "", isShowConfirmBox: false, loader: false });
          }
        });
    } else {
      this.setState({ removeId: "", isShowConfirmBox: false, loader: false });
    }
  };

  handleSearchUser = (event) => {
    this.setState({ search: event.target.value }, () => {
      this.getFieldCrewList();
    });
  };

  render() {
    const { fieldCrewData, isShowConfirmBox, count, limit, pageChange } = this.state;

    const handleOnTableChange = (type, newState) => {
      console.log("type", type);
      if (type === "sort") {
        if (newState.sortOrder == "asc") {
          fieldCrewData.sort((obj1, obj2) => {
            return obj1[newState.sortField].trim().localeCompare(obj2[newState.sortField].trim(), undefined, { numeric: true, sensitivity: 'base' })
              ;
          });
        }
        else {
          fieldCrewData.sort((obj2, obj1) => {
            return obj1[newState.sortField].trim().localeCompare(obj2[newState.sortField].trim(), undefined, { numeric: true, sensitivity: 'base' })
              ;
          });
        }
      }
    }
    const columns = [
      {
        dataField: "name",
        text: "Name",
        sort: true,
        formatter: this.imageFormat,
      },
      {
        dataField: "manager",
        text: "Project Manager",
        sort: true,

      },
      {
        dataField: "status",
        text: "Status",
        sort: true
      },
      {
        dataField: "",
        text: "Action",
        formatter: this.actionFormat,
      },
    ];

    const sizePerPageOptions = [
      {
        text: '10',
        value: 10,
      },
      {
        text: '25',
        value: 25,
      },
      {
        text: '30',
        value: 30,
      },
      {
        text: '50',
        value: 50,

      },
      {
        text: '100',
        value: 100,
      },
      // Add more options as needed
    ];

    let that = this;
    const pagination = paginationFactory({
      page: pageChange,
      sizePerPage: limit,
      lastPageText: ">>",
      firstPageText: "<<",
      nextPageText: ">",
      prePageText: "<",
      totalSize: count,
      hideSizePerPage: false,
      alwaysShowAllBtns: true,
      sizePerPageList: sizePerPageOptions,
      onPageChange: function (page, sizePerPage) {
        let skp = (page - 1) * sizePerPage;
        let filters = `?filter[skip]=${skp}&filter[limit]=${sizePerPage}`;
        that.setState({ pageChange: page, skip: skp });
        that.getFieldCrewList(filters);
      },
      onSizePerPageChange: function (sizePerPage, page) {
        let skp = (page - 1) * sizePerPage;
        that.setState({ pageChange: page, skip: skp, limit: sizePerPage });
        let filters = `?filter[skip]=${skp}&filter[limit]=${sizePerPage}`;
        that.getFieldCrewList(filters);
      }
    })

    return (
      <div>
        <div className="main-content">
          <ConfirmBox
            openModal={isShowConfirmBox}
            confirmMsg="Are you sure to delete this Field Crew?"
            handleConfirmModal={this.handleConfirmModal}
          />
          <div className="page-content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box d-flex align-items-center justify-content-between">
                    <ol className="breadcrumb m-0">
                      <Link to={`/#`}><li className="breadcrumb-item">Home</li></Link>
                      &nbsp; / &nbsp;
                      <Link to={`/fieldcrew`}><li className="breadcrumb-item">Field Crew</li></Link>
                    </ol>
                  </div>
                  <h4 className="mb-0">Field Crew List</h4>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-12">
                  <div className="card card-block">
                    <div className="card-body">
                      <div className="row mb-2">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <Link to="/addfieldcrew">
                              <span className="btn btn-success waves-effect waves-light" onClick={this.setLocalStorageItems}>
                                <i className="uil uil-plus" ></i> Add New
                              </span>
                            </Link>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-inline float-md-end mb-3">
                            <div className="search-box ms-2">

                            </div>
                          </div>
                        </div>
                      </div>
                      <BootstrapTable
                        remote={{
                          pagination: true,
                          sort: true
                        }}
                        onTableChange={handleOnTableChange}
                        keyField="id"
                        data={fieldCrewData}
                        columns={columns}
                        // pagination={paginationFactory({   sizePerPageList:sizePerPageOptions })} 
                        pagination={pagination}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
